import axios from '../axios/interceptor';

export const createBusiness = async (businessData) => {
    const response = await axios.post('/business', businessData);
    return response.data;
}
export const getBusinessesWithRoles = async () => {
    const response = await axios.get('/business/roles');
    return response.data;
}

export const getBusinessServices = async (businessId, categoryId=null) => {
    const params = categoryId ? { categoryId: categoryId } : {};
    const response = await axios.get(`/business/${businessId}/services`,{params});
    return response.data;
}

export const createBusinessService = async (businessId, serviceData, categoryId) => {
    const response = await axios.post(`/business/${businessId}/services?categoryId=${categoryId}`, serviceData);
    return response.data;
}

export const updateBusinessService = async (businessId, serviceData, serviceId,categoryId) => {
    const response = await axios.put(`/business/${businessId}/services/${serviceId}?categoryId=${categoryId}`, serviceData);
    return response.data;
}

export const deleteBusinessService = async (businessId, serviceId) => {
    const response = await axios.delete(`/business/${businessId}/services/${serviceId}`);
    return response.data;
}

export const getBusinessServiceById = async (businessId, serviceId) => {
    const response = await axios.get(`/business/${businessId}/services/${serviceId}`);
    return response.data;
}
export const getBusinessDetails = async(businessId)=>{
    const response = await axios.get(`/business/${businessId}`);
    return response.data;
}

export const updateBusinessDetails = async(businessId, businessDetails)=>{
    const response = await axios.put(`/business/${businessId}`, businessDetails);
    return response.data;
}

//Operating hours
export const getOperatingHours = async(businessId)=>{
    const response = await axios.get(`/business/${businessId}/operating_hours`);
    return response.data;
}

export const updateOperatingHours = async(businessId, operatingHoursData)=>{
    const response = await axios.put(`/business/${businessId}/operating_hours`, operatingHoursData);
    return response.data;
}

export const deleteSpecialOperatingHour = async(businessId, specialHourId)=>{
    const response = await axios.delete(`/business/${businessId}/special_hours/${specialHourId}`);
    return response.data;
}